import React from 'react';
import { Modal } from '../Modal';

interface UpdateErrorModalProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

export const UpdateErrorModal: React.FC<UpdateErrorModalProps> = ({
  isOpen,
  message,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      blockOverlayClick={true}
      hideCloseButton={true}
    >
      <div className="flex flex-col items-center gap-6 p-4 text-center">
        <p className="text-lg">{message}</p>
        <button
          className="bg-primary text-white font-bold uppercase rounded-full px-10 py-3 cursor-pointer"
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </Modal>
  );
};
